import { motion } from "framer-motion";

import lunch1 from "../../../assets/Lunch/lunch1.jpg";
import lunch2 from "../../../assets/Lunch/lunch2.jpg";
import lunch3 from "../../../assets/Lunch/lunch3.jpg";
import lunch4 from "../../../assets/Lunch/lunch4.jpg";
import lunch5 from "../../../assets/Lunch/lunch5.jpg";
import lunch6 from "../../../assets/Lunch/lunch6.jpg";
import lunch7 from "../../../assets/Lunch/lunch7.jpg";
import lunch8 from "../../../assets/Lunch/lunch8.jpg";

const lunchItems = [
  {
    title: "Thai tom kha soup",
    price: "₹690",
    img: lunch1,
  },
  {
    title: "Roasted lamb",
    price: "₹870",
    img: lunch2,
  },
  {
    title: "Tomato basil soup",
    price: "₹700",
    img: lunch3,
  },
  {
    title: "Tuna salad sandwich",
    price: "₹690",
    img: lunch4,
  },
  {
    title: "Grilled chicken with fruit salad",
    price: "₹890",
    img: lunch5,
  },
  {
    title: "Mini veggie cakes",
    price: "₹800",
    img: lunch6,
  },
  {
    title: "Greek salad",
    price: "₹800",
    img: lunch7,
  },
  {
    title: "Vegetarian wok",
    price: "₹420",
    img: lunch8,
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Lunch = () => {
  return (
    <section className="bg-neutral-100 py-20">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="font-italianno text-primary-800 text-3xl sm:text-4xl">
            Menu
          </span>

          <h2 className="text-primary-700 text-2xl sm:text-3xl xl:text-4xl font-semibold tracking-widest mt-1">
            LUNCH
          </h2>

          <div className="w-14 h-px bg-primary-400 mx-auto mt-4" />
        </motion.div>

        {/* Grid */}
       <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6 xl:gap-8">
        {lunchItems.map((item, index) => (
          <motion.div
            key={index}
            custom={index}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="bg-white overflow-hidden shadow-sm hover:shadow-lg transition-shadow"
          >
            <img
              src={item.img}
              alt={item.title}
              className="w-full h-48 sm:h-52 xl:h-56 2xl:h-60 object-cover"
            />

            <div className="p-4 xl:p-5 2xl:p-6">
              <div className="flex justify-between items-start gap-2">
                <h4 className="text-primary-700 font-semibold text-sm xl:text-base leading-snug">
                  {item.title}
                </h4>

                <span className="text-primary-800 font-semibold text-sm xl:text-base whitespace-nowrap">
                  {item.price}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      </div>
    </section>
  );
};

export default Lunch;